var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from "react";
var Select = forwardRef(function (_a, ref) {
    var placeholder = _a.placeholder, name = _a.name, id = _a.id, defaultValue = _a.defaultValue, options = _a.options, value = _a.value, maxWidth = _a.maxWidth, className = _a.className, style = _a.style, otherProps = __rest(_a, ["placeholder", "name", "id", "defaultValue", "options", "value", "maxWidth", "className", "style"]);
    var renderOptGroup = function (optGroup) {
        var optionsOfGroup = optGroup.options, otherOptGroupProps = __rest(optGroup, ["options"]);
        return (React.createElement("optgroup", __assign({ key: optGroup.label }, otherOptGroupProps), optionsOfGroup.map(renderOption)));
    };
    var renderOption = function (option) {
        var name = option.name, otherOptionProps = __rest(option, ["name"]);
        return (React.createElement("option", __assign({ key: option.value }, otherOptionProps), name));
    };
    var optionsRendered = useMemo(function () {
        return options.map(function (option) {
            if ("value" in option) {
                return renderOption(option);
            }
            else {
                return renderOptGroup(option);
            }
        });
    }, [options]);
    var styleGroup = __assign(__assign({}, style), { width: "100%", maxWidth: maxWidth || undefined });
    var selectDefaultValue;
    if (defaultValue !== undefined) {
        selectDefaultValue = defaultValue;
    }
    else if (placeholder !== undefined && value === undefined) {
        selectDefaultValue = "";
    }
    else {
        selectDefaultValue = undefined;
    }
    return (React.createElement("select", __assign({}, otherProps, { ref: ref, name: name, id: id, className: "fr-select " + (className !== null && className !== void 0 ? className : ""), style: styleGroup, value: value, defaultValue: selectDefaultValue }),
        placeholder ? (React.createElement("option", { disabled: true, hidden: true, value: "" }, placeholder)) : undefined,
        optionsRendered));
});
export default Select;
